const pcRouter = [
  {
    path: "/",
    redirect: "/index",
  },
  {
    path: "/index",
    name: "index",
    redirect: "/home",
    children: [{
        path: "/home",
        name: "home",
        meta: { auth: false, breadNumber: 0, title: 'home' },
        component: () => import("@/views/pc/home/Index"),
      },
    ]
  },
  {
    path: "/search",
    name: "search",
    meta: { auth: false, breadNumber: 0, title: 'search' },
    component: () => import("@/views/pc/search/Index"),
  },
  {
    path: "/report",
    name: "report",
    meta: { auth: false, breadNumber: 0, title: 'report' },
    component: () => import("@/views/report/report/Index"),
  },
];
export default pcRouter;
